import { call, put, takeLatest } from "redux-saga/effects"
import { GET_DIVISION_RATE_WATCHER } from "./constants"

import { getDivisionRateSuccess, getDivisionRateFailed } from "./actions"
import { getDivisionRateApi } from "../../../utils/routes/routes-report"

export function* getDivisionRateSaga(action) {
  try {
    const dataStatus = action.payload
    const { data: divisionsRate } = yield call(
      getDivisionRateApi,
      dataStatus.params
    )
    yield put(getDivisionRateSuccess(divisionsRate))
  } catch (e) {
    yield put(getDivisionRateFailed())
  }
}

export default function* widgetResponseRateReportSaga() {
  yield takeLatest(GET_DIVISION_RATE_WATCHER, getDivisionRateSaga)
}
